module.exports = __webpack_public_path__ + "static/media/king-moffatt.5c701289.png";